import { authFetch } from '../../common/networking/auth-fetch'
import { UpdateDefaultBraintreePaymentRequest } from '../../types/braintree/request/update-default-braintree-payment-request'
import { GetBraintreeTokenResponse } from '../../types/braintree/response/get-braintree-token-response'
import { CreateBraintreePaymentRequest } from '../../types/braintree/request/create-braintree-payment-request'
import { BraintreePaymentResponse } from '../../types/braintree/response/braintree-payment-response'

export async function deletePayment(
  accessToken: any,
  request: UpdateDefaultBraintreePaymentRequest,
): Promise<Response> {
  return authFetch(accessToken).delete(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/payments/customers/payments/${request.paymentToken}`,
    request,
  )
}

export async function getBrainTreeToken(
  accessToken: any,
): Promise<GetBraintreeTokenResponse> {
  let url = `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/braintree/customers/client-token`
  const response = await authFetch(accessToken).get(url)
  return await response.json()
}

export async function postCreateBrainTreePayment(
  accessToken: any,
  request: CreateBraintreePaymentRequest,
): Promise<BraintreePaymentResponse> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/braintree/customers/payment-methods`,
    request,
  )

  return await response.json()
}
